/* src/app/components/filter/quick-filters/quick-filters.component.scss */
/*# sourceMappingURL=quick-filters.component.css.map */
